import { render, staticRenderFns } from "./UserAccountMenu.vue?vue&type=template&id=2feb9c1d&scoped=true"
import script from "./UserAccountMenu.vue?vue&type=script&lang=js"
export * from "./UserAccountMenu.vue?vue&type=script&lang=js"
import style0 from "./UserAccountMenu.vue?vue&type=style&index=0&id=2feb9c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb9c1d",
  null
  
)

export default component.exports